import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "antd-mobile";
import styles from "./styles.module.scss";
import classNames from "classnames";

export interface IAppUpdateModal {
  visible: boolean;
}

export const AppUpdateModal: FC<IAppUpdateModal> = ({ visible }) => {
  const { t } = useTranslation();
  const onUpdate = () => {
    window.location.href =
      "https://apps.apple.com/us/app/circadia-cip/id1671300278";
  };
  return (
    <Modal
      visible={visible}
      className={styles.modalCon}
      closeOnMaskClick={false}
      showCloseButton={false}
      content={
        <div className={classNames(styles.content, "mt-2")}>
          <p id="sub-title" className={styles.subTitle}>
            {t("appUpdate.message")}
          </p>
          <Button
            id="update-btn"
            fill="solid"
            color="primary"
            onClick={onUpdate}
          >
            {t("appUpdate.update")}
          </Button>
        </div>
      }
    />
  );
};
